import { pick } from 'lodash';

import { doDeleteQuery, doGetQuery, doPostQuery, doPutQuery } from './utils';

export const apiAddQuestion = async (
  testUid: string,
  question: TQuestionUpdate
): Promise<string> => {
  const { questionUid } = await doPostQuery<{ questionUid: string }>(
    `questions/question/${testUid}`,
    null,
    { question }
  );
  return questionUid;
};

export const apiUpdateQuestion = async (
  questionUid: string,
  question: TQuestion
) =>
  await doPutQuery<void>(`questions/question/${questionUid}`, null, {
    question: pick(question, 'hint', 'question', 'options', 'resourceBinary'),
  });

export const apiGetQuestion = async (questionUid: string): Promise<TQuestion> =>
  await doGetQuery<TQuestion>(`questions/question/${questionUid}`);

export const apiDeleteQuestion = async (questionUid: string) =>
  await doDeleteQuery<void>(`questions/question/${questionUid}`);

export const apiMoveQuestionToTest = async (
  questionUid: string,
  testUid: string
) =>
  await doPostQuery<void>(`questions/question/move/${questionUid}/${testUid}`);

export const apiSubmitQuestion = async (
  questionUid: string,
  isCorrect: boolean
) =>
  await doPostQuery<TQuestion>(
    `questions/submit/${questionUid}?isCorrect=${Number(isCorrect)}`
  );

export const apiGetTestQuestions = (
  testUid: string,
  mode: 'pending' | 'all' = 'all'
) => doGetQuery<TQuestion[]>(`questions/list/${testUid}?mode=${mode}`);

type TSearchFilters = {
  text?: string;
};
export const apiSearchQuestions = (
  testUid: string,
  cursor: string | undefined,
  filters: TSearchFilters
) =>
  doGetQuery<{ questions: TQuestion[]; cursor: string | undefined }>(
    `questions/search`,
    {
      testUid,
      cursor,
      text: filters.text || undefined,
    }
  );
